import React from 'react';

interface SpinnerProps {
  size?: 'sm' | 'md';
  label?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', label }) => (
  <div className="flex flex-col items-center gap-4">
    <div className={`sh-spinner ${size === 'sm' ? 'sh-spinner-sm' : ''}`} role="status" aria-label={label ?? 'Loading'} />
    {label && <div className="sh-label">{label}</div>}
  </div>
);
